import { observer } from 'mobx-react-lite'
import { type ApplyCouponAsAdminDialogViewModel } from './ApplyCouponAsAdminDialogViewModel'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { type Coupon } from '@/features/billing/coupons/Coupon'
import {
  ApplyCouponAsAdminDialog,
  ApplyCouponAsAdminDialogCouponItem,
} from '@/features/jobs/ApplyCouponAsAdminDialog'

export interface ApplyCouponAsAdminDialogContainerProps {
  vm: ApplyCouponAsAdminDialogViewModel
}

export const ApplyCouponAsAdminDialogContainer = observer(
  function ApplyCouponAsAdminDialogContainer({
    vm,
  }: ApplyCouponAsAdminDialogContainerProps) {
    return (
      <ApplyCouponAsAdminDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onApply={vm.applyCouponAsAdmin}
        isApplyPending={vm.applyCouponAsAdmin.pending}
        isApplyDisabled={!vm.selectedCouponId}
        onSearch={vm.searchCoupon}
        isEmpty={vm.coupons.length === 0}
        loader={
          vm.modal.showing &&
          !vm.scrollProvider.isDone && (
            <InfiniteScrollLoaderContainer scrollProvider={vm.scrollProvider} />
          )
        }
      >
        {vm.coupons.map((coupon) => {
          return <CouponItemContainer key={coupon.id} vm={vm} coupon={coupon} />
        })}
      </ApplyCouponAsAdminDialog>
    )
  },
)

interface CouponItemContainerProps {
  vm: ApplyCouponAsAdminDialogViewModel
  coupon: Coupon
}

const CouponItemContainer = observer(function CouponItemContainer({
  vm,
  coupon,
}: CouponItemContainerProps) {
  return (
    <ApplyCouponAsAdminDialogCouponItem
      code={coupon.code}
      dateExpires={coupon.dateExpires}
      description={coupon.description}
      discount={vm.couponDiscount(coupon)}
      maxSavings={vm.couponMaxSavings(coupon)}
      isSelected={coupon.id === vm.selectedCouponId}
      onSelect={() => vm.setCoupon(coupon)}
    />
  )
})
